import React, { useCallback } from "react"
import { GenericOverview } from "../../components/Table/GenericOverview"
import { useNavigate } from "react-router-dom"
import { GenericLinks } from "../../components/Table/GenericLink"
import { ApiClient } from "../../ApiClient"
import { useAuth0 } from "@auth0/auth0-react"
import { MessageType, useMessageReport } from "../../components/MessageReporter"

export const ChangeAction = {
    Accept: "accept",
    Reject: "reject",
}

export const TranslationsChangesOverview = () => {
    const endpoint = "/v2/management/translations"

    const { getAccessTokenSilently } = useAuth0()
    const navigate = useNavigate()
    const { addMessage } = useMessageReport()

    const jsonDataField = (setData, data) => setData(data.translations)

    const filter = {
        initial: "",
    }

    const translationAction = useCallback(
        (translation, action) => {
            getAccessTokenSilently()
                .then(async (token) => {
                    if (action === ChangeAction.Accept) {
                        await ApiClient.put(
                            `/v2/management/translations/${translation.translation_id}`,
                            translation,
                            {
                                Authorization: "Bearer " + token,
                            }
                        )
                    } else {
                        await ApiClient.delete(
                            `/v2/management/translations/${translation.translation_id}`,
                            {
                                Authorization: "Bearer " + token,
                            }
                        )
                    }
                })
                .then(() => navigate("/translations"))
                .catch((err) => {
                    addMessage(
                        "Failed to accept translations",
                        "Something went wrong while accepting the translation change, " +
                            "see the console for more details.",
                        MessageType.error,
                        err
                    )
                })
        },
        [getAccessTokenSilently, navigate, addMessage]
    )

    const error = {
        title: "Failed to get translation changes",
        body: "Something went wrong while getting the translation changes, see the console for more details.",
    }

    const table = {
        header: [
            <th>App</th>,
            <th>Language</th>,
            <th>Key</th>,
            <th>Translation</th>,
            <th>Changed By</th>,
            <th>Actions</th>,
        ],
        body: (value) => (
            <tr key={value.translation_id}>
                <td>{value.app}</td>
                <td>{value.language}</td>
                <td>{value.key}</td>
                <td>{value.translation}</td>
                <td>{value.changedby}</td>
                <td>
                    <GenericLinks
                        items={[
                            {
                                onClick: () => {
                                    translationAction(value, ChangeAction.Accept)
                                },
                                text: "Accept",
                            },
                            {
                                onClick: () => {
                                    translationAction(value, ChangeAction.Reject)
                                },
                                text: "Reject",
                            },
                        ]}
                    />
                </td>
            </tr>
        ),
    }

    return (
        <>
            <h2>Translations</h2>
            <GenericOverview
                apiEndpoint={endpoint}
                dataField={jsonDataField}
                filter={filter}
                extraParam={"&accepted=false"}
                error={error}
                pagination={false}
                disableSearch={true}
                table={table}
            />
        </>
    )
}
